var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTips48Line = function SvgIconTips48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.7A16.7 16.7 0 1 1 40.7 24 16.72 16.72 0 0 1 24 40.7Zm0-30A13.3 13.3 0 1 0 37.3 24 13.31 13.31 0 0 0 24 10.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.688 29.25h-3.4v3h3.4v-3ZM25.698 27.051h-3.35v-1a4.31 4.31 0 0 1 2.44-4 1.482 1.482 0 0 0 1-1.86 1.76 1.76 0 0 0-1.22-1.23 1.841 1.841 0 0 0-1.61.31 1.79 1.79 0 0 0-.7 1.43h-3.4a5.19 5.19 0 0 1 2-4.12 5.251 5.251 0 0 1 4.54-.91 5.19 5.19 0 0 1 3.67 3.67 4.85 4.85 0 0 1-2.87 5.8 1 1 0 0 0-.45.88l-.05 1.03Z",
    fill: "current"
  })));
};
export default SvgIconTips48Line;